
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, Shield, Euro, Scale } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";

const LegalSection = () => {
  const navigate = useNavigate();
  const { t, currentLanguage } = useLanguage();

  const isGerman = currentLanguage === 'de';

  return (
    <Card className="bg-gray-900/80 border-gray-600">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-ice-white">
          <Scale className="w-5 h-5 text-pink-500" />
          {isGerman ? 'Rechtliches & Preise' : 'Legal & Pricing'}
        </CardTitle>
        <CardDescription className="text-gray-300">
          {isGerman 
            ? 'Rechtliche Informationen und transparente Preisgestaltung'
            : 'Legal information and transparent pricing'
          }
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={() => navigate('/pricing')}
        >
          <Euro className="w-4 h-4 mr-2" />
          {isGerman ? 'Preise & Abonnements' : 'Pricing & Subscriptions'}
        </Button>
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={() => navigate('/cancellation-rights')}
        >
          <FileText className="w-4 h-4 mr-2" />
          {isGerman ? 'Widerrufsrecht' : 'Cancellation Rights'}
        </Button>
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={() => navigate('/terms-of-service')}
        >
          <FileText className="w-4 h-4 mr-2" />
          {t('signOut') === 'Sign Out' ? 'Terms of Service' : 'Nutzungsbedingungen'}
        </Button>
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={() => navigate('/privacy-policy')}
        >
          <Shield className="w-4 h-4 mr-2" />
          {t('signOut') === 'Sign Out' ? 'Privacy Policy' : 'Datenschutzerklärung'}
        </Button>
      </CardContent>
    </Card>
  );
};

export default LegalSection;
